import { Button, Container, Table, Text, Title } from "@mantine/core";

// TODO fix types
export const SubmitPage = ({
  data,
  totalScore,
  maxScore,
  traineeId,
  next,
  back,
}: any) => {
  return (
    <div>
      <Container p="xl">
        <Table>
          <thead>
            <tr>
              <th>
                <Text color="orange">PARAMETER</Text>
              </th>
              <th>
                <Text color="orange">RATING</Text>
              </th>
              <th>
                <Text color="orange">COMMENTS</Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row: any, index: any) => (
              <tr key={index}>
                <th scope="row">
                  <Text>{row.name}</Text>
                </th>
                <td align="left">
                  <Text>{row.score}</Text>
                </td>
                <td align="left">
                  <Text>{row.comment}</Text>
                </td>
              </tr>
            ))}
            <tr key="score">
              <td>
                <Title order={5}>
                  Total: {totalScore}/{maxScore}
                </Title>
              </td>
              <td align="left">
                <Title order={6}>Trainee ID: {traineeId}</Title>
              </td>
              <td align="left">
                <Button color="orange" onClick={next}>
                  SUBMIT
                </Button>
              </td>
              <td align="left">
                <Button color="orange" onClick={back}>
                  BACK
                </Button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Container>
    </div>
  );
};
